(function() {
	'use strict';

	/**
	 * @ngdoc service
	 * @name dutySheet.service:DutySheetService
	 * 
	 * @description
	 * 
	 */
	angular.module('dutySheet').service('DutySheetService', DutySheetService);

	function DutySheetService(DutySheetFactory, RemoteService) {

		var self = this;

		// store retrieved data
		var model = {
			dutySheetSearchRequest : DutySheetFactory
					.getDutySheetSearchRequest(),
			standByDetailSearchRequest : DutySheetFactory
					.getStandByDetailSearchRequest(),
			deadHeadingSearchRequest : DutySheetFactory
					.getDeadHeadingSearchRequest(),
			readyToWorkSearchRequest : DutySheetFactory
					.getReadyToWorkSearchRequest(),
      reportSickSearchRequest : DutySheetFactory
          .getReportSickSearchRequest(),
			otherDutyTypeDetailSearchRequest : DutySheetFactory
					.getOtherDutyTypeDetailSearchRequest(),
			searchDutyList : null,
			searchStandBYDetails : [],
			searchDeadHeadingDetails : [],
			searchReadyToWorkDetails : [],
			searchReportSickDetails : [],
			searchOtherDutyTypeDetails : [],
			adaptedDuties : [],
			searchCrieteria : DutySheetFactory.getSearchCrieteriaObject(),
			sendEmailRequest : {},
			printJourneyLogParams: {}
		};

		self.getInitialSearchCrieteria = function() {
			return model.searchCrieteria;
		}

		self.setDutySheetSearchRequest = function(searchCrieteria) {
			model.dutySheetSearchRequest = DutySheetFactory
					.getFormattedDutySheetSearchRequest(searchCrieteria);
			model.standByDetailSearchRequest = DutySheetFactory
					.getFormattedStandByDetailSearchRequest(searchCrieteria);
			model.deadHeadingSearchRequest = DutySheetFactory
					.getFormattedDeadHeadingSearchRequest(searchCrieteria);
			model.readyToWorkSearchRequest = DutySheetFactory
					.getFormattedReadyToWorkSearchRequest(searchCrieteria);
      model.reportSickSearchRequest = DutySheetFactory
          .getFormattedReportSickSearchRequest(searchCrieteria);
			model.otherDutyTypeDetailSearchRequest = DutySheetFactory
					.getFormattedOtherDutyTypeDetailSearchRequest(searchCrieteria);
		}

		self.searchDuties = function(successFn, errorFn, searchRequest) {
			if(!!searchRequest){ 			
				model.dutySheetSearchRequest = DutySheetFactory
				.getFormattedDutySheetSearchRequest(searchRequest);
			}
			RemoteService.searchDuties(model.dutySheetSearchRequest).then(
					function(response) {
						if (response.success && !!response.dutyDetailDTOs) {
							model.searchDutyList = response.dutyDetailDTOs;
							successFn(model.searchDutyList, response.illigalDutiesList, response.dutySheetHidePersonalDetailsEnabled);
						}
					}, function(error) {
						errorFn(error.msg[0]);
					});
		};
		
		self.searchDutiesLegality = function(searchRequest,successFn, errorFn ) {
			if(searchRequest == null || searchRequest.length == 0){
				return;
			}
			
			var request = {"regulationSearchList":searchRequest};
			RemoteService.searchDutiesLegality(request).then(
					function(response) {
						if (response.success && !!response.regulation) {
							successFn(response.regulation);
						}
					}, function(error) {
						errorFn(error.msg[0]);
					});
		 };
		
		

		self.searchStandByDetails = function(successFn, errorFn, searchRequest) {
			if(!!searchRequest){ 
				model.standByDetailSearchRequest = DutySheetFactory
						.getFormattedStandByDetailSearchRequest(searchRequest);				
			}
			RemoteService
					.searchStandByDetails(model.standByDetailSearchRequest)
					.then(
							function(response) {
								if (response.success
										&& !!response.standbyDetails) {
									model.searchStandBYDetails = response.standbyDetails;
									successFn(model.searchStandBYDetails);
								}
							}, function(error) {
								errorFn(error.msg[0]);
							});
		};

		self.searchDeadHeadingDetails = function(successFn, errorFn, searchRequest) {
			if(!!searchRequest){ 
				model.deadHeadingSearchRequest = DutySheetFactory
				.getFormattedDeadHeadingSearchRequest(searchRequest);
			}
			RemoteService
					.searchDeadHeadingDetails(model.deadHeadingSearchRequest)
					.then(
							function(response) {
								if (response.success
										&& !!response.deadHeadingDetails) {
									model.searchDeadHeadingDetails = response.deadHeadingDetails;
									successFn(model.searchDeadHeadingDetails);
								}
							}, function(error) {
								errorFn(error.msg[0]);
							});
		};

		self.searchReadyToWorkDetails = function(successFn, errorFn, searchRequest) {
			if(!!searchRequest){
				model.readyToWorkSearchRequest = DutySheetFactory
						.getFormattedReadyToWorkSearchRequest(searchRequest);
			}
			RemoteService
					.searchReadyToWorkDetails(model.readyToWorkSearchRequest)
					.then(
							function(response) {
								if (response.success
										&& !!response.readyToWorkDetails) {
									model.searchReadyToWorkDetails = response.readyToWorkDetails;
									successFn(model.searchReadyToWorkDetails);
								}
							}, function(error) {
								errorFn(error.msg[0]);
							});
		};

    self.searchReportSickDetails = function(successFn, errorFn, searchRequest) {
      if(!!searchRequest){
        model.reportSickSearchRequest = DutySheetFactory
          .getFormattedReportSickSearchRequest(searchRequest);
      }
      RemoteService
        .searchReportSickDetails(model.reportSickSearchRequest)
        .then(
          function(response) {
            if (response.success
              && !!response.readyToWorkDetails) {
              model.reportSickDetails = response.readyToWorkDetails;
              successFn(model.reportSickDetails);
            }
          }, function(error) {
            errorFn(error.msg[0]);
          });
    };

    self.searchOtherDutyTypeDetails = function(successFn, errorFn, searchRequest) {
			if(!!searchRequest){ 
				model.otherDutyTypeDetailSearchRequest = DutySheetFactory
						.getFormattedOtherDutyTypeDetailSearchRequest(searchRequest);
			}
			RemoteService
					.searchOtherDutyTypeDetails(
							model.otherDutyTypeDetailSearchRequest)
					.then(
							function(response) {
								if (response.success
										&& !!response.deadHeadingDetails) {
									model.searchOtherDutyTypeDetails = response.deadHeadingDetails;
									successFn(model.searchOtherDutyTypeDetails);
								}
							}, function(error) {
								errorFn(error.msg[0]);
							});
		}

		self.getFormattedDuties = function(duties) {
			model.adaptedDuties = DutySheetFactory.getFormattedDutyList(duties);
			return model.adaptedDuties;
		}
		
		self.getFormatFlightDuty = function(duty) {
			return DutySheetFactory.getFormattedFlightDuty(duty);
		}
		
		self.sendEmail = function(selectedBlockIds, successFn, errorFn) {
			model.sendEmailRequest = DutySheetFactory
					.getFormattedSendEmailRequest(selectedBlockIds);

			RemoteService.sendEmail(model.sendEmailRequest).then(
					function(response) {
						successFn(response);
					}, function(error) {
						errorFn(error.msg[0]);
					});
		};
		
		self.getCrewIdsBySelectedStandBy= function(selectedStandByList){
			var crewIds = '';
			for(var i=0; i<selectedStandByList.length;i++){
				crewIds+=selectedStandByList[i].crewId+',';
			}
			if(crewIds.length>0){
				crewIds = crewIds.slice(0, -1);
			}
			return crewIds;
		};
		
		self.getFormattedJourneyLogPrintParamByDHD = function(selectedDHD){
			model.printJourneyLogParams = DutySheetFactory.getFormattedJourneyLogPrintParamByDHD(selectedDHD);
			return model.printJourneyLogParams;
		};
		
		self.getFormattedJourneyLogPrintParamByDuty = function(selectedDuty){
			model.printJourneyLogParams = DutySheetFactory.getFormattedJourneyLogPrintParam(selectedDuty);
			return model.printJourneyLogParams;
		};
		
		
		self.getJourneyLogRq = function(selectedDuty){
           return DutySheetFactory.getJourneyLogRQ(selectedDuty);
        };
        
        
        self.getJourneyLogData = function (params, successFn, errorFn) {
            RemoteService.getJourneyLogData(params).then(
                function(response){
                    successFn(response)
                },
                function (error) {
                    errorFn(error);
                }
            )  
        };
        
        self.updateCheckedBy = function (blockId, version, successFn, errorFn) {
            RemoteService.updateCheckedBy(blockId, version).then(
                    function(response){
                        successFn(response)
                    },
                    function (error) {
                        errorFn(error);
                    }
                )  
            };
            
        self.submitJourneyLog = function (blockId, version, successFn, errorFn) {
                RemoteService.submitJourneyLog(blockId, version).then(
                        function(response){
                            successFn(response)
                        },
                        function (error) {
                            errorFn(error);
                        }
                    )  
                };
	}
})();
